module.exports = __webpack_public_path__ + "img/panama-logo-icon.a5f92f32.png";